import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76577cb8")

_pushScopeId("data-v-76577cb8")
const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("设备管理")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增型号")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("新增设备")
const _hoisted_7 = {
  key: 0,
  class: "table-div"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "table-div"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "table-div"
}
const _hoisted_12 = {
  key: 1,
  style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","word-break":"break-all"}
}
const _hoisted_13 = {
  key: 0,
  class: "table-div"
}
const _hoisted_14 = {
  key: 1,
  style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","word-break":"break-all"}
}
const _hoisted_15 = {
  key: 0,
  class: "gray-icon"
}
const _hoisted_16 = {
  key: 1,
  class: "goldenrod-icon"
}
const _hoisted_17 = {
  key: 2,
  class: "mediumseagreen-icon"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("远程调试")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("释放设备")
const _hoisted_20 = { class: "dialogTitle" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "设备注册", -1)
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("注册设备")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("重置")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_space = _resolveComponent("el-space")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_card = _resolveComponent("el-card")
  const _component_Paging = _resolveComponent("Paging")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_RegisterDevice = _resolveComponent("RegisterDevice")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_breadcrumb, {
                "separator-class": "el-icon-arrow-right",
                class: "PosTitle"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode("div", _hoisted_2, [
                      _createVNode(_component_el_breadcrumb_item, null, {
                        default: _withId(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_breadcrumb_item, null, {
                        default: _withId(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", null, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini",
                        onClick: _ctx.handleRegisterDevice,
                        class: "",
                        disabled: _ctx.get_is_super
                      }, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini",
                        onClick: _ctx.handleRegisterDeviceForm,
                        class: "",
                        disabled: _ctx.get_is_super
                      }, {
                        default: _withId(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider),
              _withDirectives(_createVNode(_component_el_card, { class: "tableMinH spacName" }, {
                default: _withId(() => [
                  _createVNode(_component_el_table, {
                    size: "small",
                    data: _ctx.getDevices(_ctx.search),
                    style: {"width":"100%"},
                    "header-cell-class-name": "tabelHeader"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "remark",
                        label: "设备id",
                        width: "80"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("span", null, _toDisplayString(scope.row.id), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "remark",
                        label: "设备序列号",
                        "min-width": "160"
                      }, {
                        default: _withId((scope) => [
                          (scope.row.isEdit)
                            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                                _createVNode("input", {
                                  type: "text",
                                  class: "table-input",
                                  name: "remark",
                                  id: scope.row.id,
                                  value: scope.row.remark
                                }, null, 8, ["id", "value"])
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(scope.row.remark), 1))
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskFields1, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          key: item.label,
                          index: index,
                          label: item.label,
                          prop: item.prop
                        }, null, 8, ["index", "label", "prop"]))
                      }), 128)),
                      _createVNode(_component_el_table_column, {
                        prop: "level",
                        label: "档位",
                        width: "180"
                      }, {
                        default: _withId((scope) => [
                          (scope.row.isEdit)
                            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                                _createVNode(_component_el_select, {
                                  modelValue: scope.row.level,
                                  "onUpdate:modelValue": ($event: any) => (scope.row.level = $event),
                                  placeholder: "请选择档位",
                                  name: "level",
                                  id: 'level' + scope.row.id,
                                  size: "mini",
                                  onChange: ($event: any) => (_ctx.selectSceneChange(scope.row))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Level, (specs) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: specs.value,
                                        label: specs.label,
                                        value: specs.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "id", "onChange"])
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.Level.filter((item) => item.value === scope.row.level)[0]
                      ?.label), 1))
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskFields2, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          key: item.label,
                          index: index,
                          label: item.label,
                          prop: item.prop,
                          width: item.width
                        }, null, 8, ["index", "label", "prop", "width"]))
                      }), 128)),
                      _createVNode(_component_el_table_column, {
                        prop: "debug_url",
                        label: "调试URL",
                        "min-width": "100"
                      }, {
                        default: _withId((scope) => [
                          (scope.row.isEdit)
                            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                                _createVNode("input", {
                                  type: "text",
                                  class: "table-input",
                                  name: "debug_url",
                                  id: 'debug_url' + scope.row.id,
                                  value: scope.row.debug_url
                                }, null, 8, ["id", "value"])
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(scope.row.debug_url), 1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "note",
                        label: "备注",
                        "min-width": "100"
                      }, {
                        default: _withId((scope) => [
                          (scope.row.isEdit)
                            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                                _createVNode("input", {
                                  type: "text",
                                  class: "table-input",
                                  name: "note",
                                  id: 'note' + scope.row.id,
                                  value: scope.row.note
                                }, null, 8, ["id", "value"])
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(scope.row.note), 1))
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskFields3, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          key: item.label,
                          index: index,
                          label: item.label,
                          prop: item.prop,
                          width: item.width
                        }, null, 8, ["index", "label", "prop", "width"]))
                      }), 128)),
                      _createVNode(_component_el_table_column, {
                        prop: "status",
                        label: "状态",
                        width: "50"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("div", {
                            onClick: ($event: any) => (_ctx.a(scope.row)),
                            class: "icon-warp"
                          }, [
                            (scope.row.status === 0)
                              ? (_openBlock(), _createBlock("i", _hoisted_15))
                              : _createCommentVNode("", true),
                            (scope.row.status === 1)
                              ? (_openBlock(), _createBlock("i", _hoisted_16))
                              : _createCommentVNode("", true),
                            (scope.row.status === 2)
                              ? (_openBlock(), _createBlock("i", _hoisted_17))
                              : _createCommentVNode("", true)
                          ], 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        align: "right",
                        width: "330px"
                      }, {
                        header: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.search1,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search1 = $event)),
                            size: "mini",
                            placeholder: "输入关键字搜索",
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearch()))
                          }, null, 8, ["modelValue"])
                        ]),
                        default: _withId((scope) => [
                          _createVNode(_component_el_space, { wrap: "" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_popconfirm, {
                                "confirm-button-text": "确认",
                                "cancel-button-text": "取消",
                                icon: _ctx.InfoFilled,
                                "icon-color": "#626AEF",
                                title: "确认跳转调试URL",
                                onConfirm: ($event: any) => (_ctx.release1(scope.row)),
                                onCancel: _ctx.cancelEvent
                              }, {
                                reference: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "success",
                                    size: "mini"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_18
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["icon", "onConfirm", "onCancel"]),
                              _createVNode(_component_el_popconfirm, {
                                "confirm-button-text": "确认",
                                "cancel-button-text": "取消",
                                icon: _ctx.InfoFilled,
                                "icon-color": "#626AEF",
                                title: "确认释放设备",
                                onConfirm: ($event: any) => (_ctx.release(scope.row)),
                                onCancel: _ctx.cancelEvent
                              }, {
                                reference: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_19
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["icon", "onConfirm", "onCancel"]),
                              _createVNode(_component_el_button, {
                                size: "mini",
                                disabled: _ctx.get_is_super,
                                type: scope.row.info,
                                onClick: ($event: any) => (_ctx.handleEdit(scope.row, _ctx.deviceUpdateForm))
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(scope.row.handleEditText), 1)
                                ]),
                                _: 2
                              }, 1032, ["disabled", "type", "onClick"]),
                              _createVNode(_component_el_popconfirm, {
                                onConfirm: ($event: any) => (_ctx.handleDeleteDevice(_ctx.deviceUpdateForm, scope.row)),
                                title: scope.row.handleConfirmText
                              }, {
                                reference: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    size: "mini",
                                    type: scope.row.isDanger,
                                    disabled: _ctx.get_is_super
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(scope.row.handleDeleteText), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["type", "disabled"])
                                ]),
                                _: 2
                              }, 1032, ["onConfirm", "title"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_el_dialog, {
                    width: "30%",
                    title: "设备注册",
                    "z-index": 1999,
                    modelValue: _ctx.handleRegisterForm,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleRegisterForm = $event)),
                    onClose: _ctx.closeRegisterDeviceForm
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode("span", _hoisted_22, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitRegisterForm()))
                        }, {
                          default: _withId(() => [
                            _hoisted_23
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: _ctx.resetRegisterDeviceForm
                        }, {
                          default: _withId(() => [
                            _hoisted_24
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.deviceRegisterForm,
                        rules: _ctx.rules,
                        class: "demo-deviceUpdateForm",
                        size: "small",
                        "label-position": "top",
                        "label-width": "30px",
                        style: {"justify-content":"space-between"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, {
                            label: "序列号",
                            prop: "remark"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.deviceRegisterForm.remark,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.deviceRegisterForm.remark = $event)),
                                placeholder: "请输入序列号",
                                style: {"width":"150px"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "设备型号",
                            prop: "Model"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.deviceRegisterForm.Model,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.deviceRegisterForm.Model = $event)),
                                placeholder: "请输入设备型号",
                                style: {"width":"150px"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "规格",
                            prop: "level"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.deviceRegisterForm.level,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.deviceRegisterForm.level = $event)),
                                placeholder: "请选择档位",
                                style: {"width":"150px"}
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Level, (specs) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: specs.value,
                                      label: specs.label,
                                      value: specs.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "rules"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onClose"])
                ]),
                _: 1
              }, 512), [
                [_directive_loading, _ctx.loading]
              ]),
              _createVNode(_component_el_footer, { class: "footerStyle" }, {
                default: _withId(() => [
                  _createVNode(_component_Paging, {
                    onOnPaging: _ctx.onPaging,
                    totalNum: _ctx.totalNum
                  }, null, 8, ["onOnPaging", "totalNum"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_RegisterDevice, { ref: "registerDeviceRef" }, null, 512)
    ]),
    _: 1
  }))
})